module.exports = __webpack_public_path__ + "static/img/mylogo.44511e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mylogo.png
// module id = UX5u
// module chunks = 20